import React, { Component } from 'react';
import Slider from "react-slick";

class SkinStories extends Component {
	render() {
		var settings = {
            slidesToShow: 2,
			autoplay: false,
			speed: 2000,
			slidesToScroll: 2,
			arrows: true,
			responsive: [{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					slidesToScroll: 1
				}
			}]
		};
		return (
			<section className="skinstories">
				<div className="container-fluid">
					<div className="skinstories__heading">
						<h1>Skin Stories</h1>
					</div>
					<div className="skin__story">
						<Slider {...settings}>
							<div className="skin__story-single">
								<div className="row">
									<div className="col-md-12">
										<div className="row flex-column-reverse flex-md-row">
											<div className="col-md-7">
												<div className="skinstories__content">
													<h1>“I've been really happy with the results. Being able to delegate my skincare, is everything.”</h1>
													<span>Julia, Singapore</span>
													<p className="arrow__space d-block"></p>
												</div>
											</div>
											<div className="col-md-5">
												<div className="skinstories__video">
													<img src="images/home/story-v1.png" alt="" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="skin__story-single">
								<div className="row">
									<div className="col-md-12">
										<div className="row">
											<div className="col-md-5">
												<div className="skinstories__video">
													<img src="images/home/story-v2.png" alt="" />
												</div>
											</div>
											<div className="col-md-7">
												<div className="skinstories__content text-left">
													<h1>“Life after Yours is simple, it's lightweight. The next day I wake up with my skin feeling soft.”</h1>
													<span>Julia, Singapore</span>
													<p className="arrow__space d-block"></p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="skin__story-single">
								<div className="row">
									<div className="col-md-12">
										<div className="row flex-column-reverse flex-md-row">
											<div className="col-md-7">
												<div className="skinstories__content">
													<h1>“I've been really happy with the results. Being able to delegate my skincare, is everything.”</h1>
													<span>Julia, Singapore</span>
													<p className="arrow__space d-block"></p>
												</div>
											</div>
											<div className="col-md-5">
												<div className="skinstories__video">
													<img src="images/home/story-v1.png" alt="" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="skin__story-single">
								<div className="row">
									<div className="col-md-12">
										<div className="row">
											<div className="col-md-5">
												<div className="skinstories__video">
													<img src="images/home/story-v2.png" alt="" />
												</div>
											</div>
											<div className="col-md-7">
												<div className="skinstories__content text-left">
													<h1>“Life after Yours is simple, it's lightweight. The next day I wake up with my skin feeling soft.”</h1>
													<span>Julia, Singapore</span>
													<p className="arrow__space d-block"></p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Slider>
					</div>
				</div>
			</section>
		);
	}
}

export default SkinStories